/**
 * マニフェスト管理
 * 最終処分完了報告(最資源化対応)
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/final_disposal_reports/manifest_type_checks`

const final_disposal_manifest_type_check = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 最終処分終了報告(紙形式)
     * マニフェスト種別のチェック処理
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.params
     * @property param1.params.manifest_ids { Array } マニのID
     * @return {Promise<unknown>}
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          resolve(data)
        } )
      })
    },

  },
  mutations: {},
}

export default final_disposal_manifest_type_check
